<template>
  <div class="rbd-content">
    <vue-particles
      class="rbd-particles"
      color="#12b4ff"
      :particleOpacity="0.7"
      :particlesNumber="160"
      shapeType="circle"
      :particleSize="4"
      :lineLinked="false"
      :moveSpeed="1"
      :hoverEffect="false"
      hoverMode="grab"
      :clickEffect="false"
      clickMode="push"
    >
    </vue-particles>

    <div class="paltform-body">
      <swiper :options="mySwiperOption">
        <swiper-slide
          v-for="(swiperItem, swiperIdx) in paltformList"
          :key="swiperIdx"
        >
          <div
            class="flex-middle"
            style="width: 100%; height: 100%; justify-content: center"
          >
            <div
              class="paltform-card"
              v-for="(item, index) in swiperItem"
              :key="index"
            >
              <div class="logo">
                <img :src="platformIconObj[item.icon]" alt="" />
              </div>
              <a-button
                class="rbd-button"
                :loading="item.loading"
                @click.stop="onClick(item)"
              >
                {{ item.platform_name }}
              </a-button>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>

    <div class="rbd-back flex-middle" @click="onClickExit">
      <i class="iconfont icon-jieshu"></i><span>退出</span>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import platformIconObj from "../utils/platform/platformIcon.js";
import { mapMutations } from "vuex";
import { __FUNC__ } from "../utils/func.js";
import {
  apiUserLoginOut,
  apiChoicePlatform,
  apiGetCommonConfig,
} from "../services/commonApi";
import VueParticles from "vue-particles"; // 粒子效果
//引入 vue-awesome-swiper 样式
import "swiper/css/swiper.css";
Vue.use(VueParticles);
export default {
  name: "PlatformSelection",
  components: {},
  data() {
    return {
      paltformList: [],
      platformIconObj: {},
      mySwiperOption: {
        speed: 600,
        observer: true,
        observeP: true,
        loop: false,
        navigationShow: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  created() {
    const that = this;
    that.platformIconObj = platformIconObj;
    const platform = JSON.parse(window.sessionStorage.getItem("PLANT_FRONT"));
    platform.map((v) => {
      v.loading = false;
    });
    // 单个盒子不能超过四个卡片
    for (let i = 0; i <= platform.length; i += 4) {
      if (i === platform.length) {
        return;
      }
      that.paltformList.push(platform.slice(i, i + 4));
    }
    // 中间页默认设置名称
    document.title = "一体化服务平台";
  },
  methods: {
    ...mapMutations([
      "mtt_removeUser",
      "mtt_removeLogoConfig",
      "mtt_authMenu",
      "mtt_authNav",
      "mtt_setPlatformInfo",
      "mtt_removePlatformInfo",
      "mtt_logoConfig",
    ]),

    // 退出
    onClickExit() {
      apiUserLoginOut({}).then(() => {
        //清除用户信息
        this.mtt_removeUser();
        this.mtt_removeLogoConfig();
        this.mtt_removePlatformInfo();
        window.localStorage.removeItem("_PLATFORM_KEY");
        window.sessionStorage.removeItem("PLATFRONT");
        window.location.href = "/user/login/login_out/";
      });
    },
    // 点击平台
    onClick(info) {
      const that = this;
      //存储用户菜单
      let authRoutes = __FUNC__.getAuthRoutes(info);
      that.mtt_authMenu(authRoutes);
      that.mtt_setPlatformInfo(info);
      info.loading = true;
      //  logo配置
      apiGetCommonConfig()
        .then(({ data: { icon, logo, backend } }) => {
          const logoConfig = {
            icon: icon ?? null,
            logo: logo ?? null,
            backend: backend ?? { title: "", font: "微软雅黑" },
            front: { title: info.platform_name },
          };
          // 存储logo配置
          that.mtt_logoConfig(logoConfig);
          document.querySelector("#browserIcon").href = logoConfig.icon;
          document.title = logoConfig.front.title;
        })
        .finally(() => {
          apiChoicePlatform({ platform_id: info.platform_id })
            .then(() => {
              if (info.index_url) {
                that.$router.push({ name: info.index_url });
              } else {
                that.$router.push({ name: authRoutes[0] });
              }
              info.loading = false;
            })
            .catch(() => {
              info.loading = false;
            });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.rbd-content {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100vh;
  background: url("../assets/images/forestage/platformSelection/img-bg.png")
    no-repeat;
  background-size: 100% 100%;
  .rbd-particles {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
  }
  .paltform-body {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding: 0 50px;

    .paltform-card {
      margin: 0 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      width: 20%;
      max-width: 360px;
      aspect-ratio: 9 / 14;
      padding: 40px 0;
      background: #ffffff;
      border-radius: 10px;
      border: 1px solid transparent;
      cursor: pointer;
      transition: all 0.3s;
      box-shadow: 0px 4px 16px 0px rgba(0, 30, 105, 0.2);
      .logo {
        width: 100%;
        text-align: center;
        img {
          width: 94%;
        }
      }

      .rbd-button {
        width: 80%;
        height: 56px;
        border: 2px solid rgba(0, 72, 205, 0.5);
        border-radius: 6px;
        font-size: 22px;
        font-weight: 400;
        color: #0b5edd;
        animation: 0.2;

        &:hover {
          background-color: #0048cd;
          color: #fff;
        }
      }
    }
  }

  .rbd-back {
    position: absolute;
    top: 20px;
    right: 32px;
    z-index: 2;
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer;
    transition: all 0.3;
    font-size: 18px;
    i {
      font-size: 18px;
      margin-top: 3px;
    }
    span {
      margin-left: 8px;
    }

    &:hover {
      color: rgba(255, 255, 255, 1);
    }
  }
}
::v-deep .swiper-container {
  height: 100%;
}
::v-deep .swiper-button-prev,
::v-deep .swiper-button-next {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.2);
  &::after {
    font-size: 20px;
    color: rgba(255, 255, 255, 0.6);
  }
  &:hover {
    &::after {
      color: rgba(255, 255, 255, 1);
    }
  }
}
</style>
